export default function (element, data) {
    var elements = document.querySelectorAll('.open-popup');
    
    setTimeout(() => {
        elements.forEach(button => {
            addClickListener(button, button.getAttribute('data-popup_id'));
        });
    }, 1000);

    function addClickListener(element, popupId) {
        const popupContainerSelector = `#partner_${popupId}`;
        const popupBlockSelector = `${popupContainerSelector} .popup-block`;
    
        const closeBtn = document.querySelector(`${popupContainerSelector} .close-btn`);
        const popupBlock = document.querySelector(popupBlockSelector);
        const popupContainer = document.querySelector(popupContainerSelector);
    
        closeBtn.addEventListener("click", function() {
            window.dispatchEvent(new CustomEvent('closeformpopup-partner', { detail: { popupId } }));
        });
    
        element.addEventListener("click", function() {
            window.dispatchEvent(new CustomEvent('openformpopup-partner', { detail: { popupId } }));
        });
    
        popupContainer.addEventListener("click", function() {
            window.dispatchEvent(new CustomEvent('closeformpopup-partner', { detail: { popupId } }));
        });
    
        popupBlock.addEventListener("click", function(event) {
            event.stopPropagation();
        });
    
        window.addEventListener("openformpopup-partner", function(event) {
            if (event.detail.popupId === popupId) {
                window.dispatchEvent(new CustomEvent('closemobilemenu'));
                popupContainer.style.display = 'flex';
                setTimeout(() => {
                    popupContainer.classList.add("open");
                }, 10);
                document.body.classList.add("no-scroll");
            }
        });
    
        window.addEventListener("closeformpopup-partner", function(event) {
            if (event.detail.popupId === popupId) {
                popupContainer.classList.remove("open");
                document.body.classList.remove("no-scroll");
                setTimeout(() => {
                    popupContainer.style.display = 'none';
                }, 300);
            }
        });
    }
};
